var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
  'checkbox': true,
  'checkbox-with-errors': _vm.errored
}},[_c('div',{staticClass:"checkbox-content"},[_c('input',_vm._b({staticClass:"checkbox-input",attrs:{"type":"checkbox","name":_vm.name,"id":_vm.htmlId},domProps:{"value":_vm.value,"checked":_vm.value},on:{"input":_vm.onChange}},'input',_vm.inputConfig,false)),_c('label',{staticClass:"checkbox-label",attrs:{"for":_vm.htmlId}},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }